
<div class="padding-20 ui-g" id="c3_searchAccumulatorsModal">

  <div class="ui-dialog-footer fixed-buttons buttonsContainer">
    <button pButton (click)="onClickAnnulla_ModalAccumulatori()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <button pButton type="button" (click)="onClickAggiungi_ModalAccumulatori()" type="button" class="k-generic-btn footer-btn" label="{{'common.confirm' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>
 <br />
 <br />
 <br />


  <app-campaign-3-kontable
  *ngIf="show.table && srvCalTranslate"
  [columns] = "[
  { field: 'id', title: 'Id' },
  { field: 'acmDescription', title: 'campaign.accumulator' },
  { field: 'channelDescription', title: 'campaign.channel' },
  { field: 'dateStart', title: 'campaign.startDate', bodyTemplate: dateStartTemplate, filterType: dateFilter },
  { field: 'dateEnd', title: 'campaign.endDate', bodyTemplate: dateEndTemplate, filterType: dateFilter },
  { field: 'acm_code', title: 'campaign.code' },
  { field: 'acmTypeDescription', title: 'campaign.acc_type' }
]"

  [paginationType]="paginationType"
  [showInfoButton]="false"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showSelectButton]="true"
  [source]="listAcm"
  (onSelected)="onAcmSelected($event)"
  #{{name}}>


<ng-template #dateStartTemplate data-testid="dateStartTemplate" let-row>
  <span>{{row.dateStart | date: this.srvCalTranslate.pcalendarTranslate.dateFormatFilter }}</span>
</ng-template>

<ng-template #dateEndTemplate data-testid="dateEndTemplate" let-row>
  <span>{{row.dateEnd | date: this.srvCalTranslate.pcalendarTranslate.dateFormatFilter }}</span>
</ng-template>



</app-campaign-3-kontable>
 <br />


 

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-accumulators/campaign-3-search-accumulators.component.html